module.exports = __webpack_public_path__ + "img/advantage1.a847486d.png";